import { createSelector } from '@reduxjs/toolkit'
import { State } from '../types'
import { StockListState } from './StockListTypes'

const selectFeature = (state: State) => state.stockList

export const selectStock = createSelector(
  selectFeature,
  (state: StockListState) => state.stock,
)

export const selectFilters = createSelector(
  selectFeature,
  (state: StockListState) => state.filters,
)

export const selectPage = createSelector(
  selectFeature,
  (state: StockListState) => state.page,
)

export const selectHasNextPage = createSelector(
  selectFeature,
  (state: StockListState) => state.stock.length < state.totalItems,
)
